<template>
    <div class="voice-call">
        <div class="info-cont">
            <div class="logo">
                <p class="tit">请选择店铺logo：</p>
                <img :src="logoImgUrl?logoImgUrl:('https://hxypic.oss-cn-hangzhou.aliyuncs.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png')" alt="">
                <div class="upload-img">
                    <i class="iconfont icon-xiazai" title="上传图片"></i>
                    <input type="file" @change="cropImg" name="logo" id="">
                </div>
            </div>
            <div class="desc">
                <p class="tit">请填写店铺简介：</p>
                <textarea maxlength="300" v-model="desc" name="desc" id="" cols="30" rows="10" placeholder="这里填写店铺信息，字数限制在300字内。"></textarea>
                <span class="font-count">{{nowFontCount}}/300</span>
            </div>
            <div class="upload">
                <button @click="uploadStoreInfo">上传</button>
            </div>
            <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
        </div>
    </div>
</template>

<script>
import imgCrop from '@/components/imgCrop/imgCrop.vue';

export default {
    name:"voiceCall",
    components:{imgCrop},
    props: ['curStoreId'],
    data () {
        return {
            nowFontCount:0,
            desc:"",
            showCrop:false,
            oldImgBase64:"",
            curCropW: 600, // 裁剪宽度
            curCropH: 600, // 裁剪高度
            logoImgUrl:""
        }
    },
    watch:{
        desc(val){
            this.nowFontCount = val.length;
            if(val.length >= 300){
                this.$message({
                    message: '已达到最大字数限制',
                    customClass: 'error'
                })
            }
        }
    },
    methods: {
        //上传图片
        cropImg(e){
            let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let _this = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = _this.result; //获得图片的base64的数据
                            that.oldImgBase64 = imgBase64;
                            that.showCrop = true;
                        };
                    };
                })(e.target.files[0]);

                reader.readAsDataURL(e.target.files[0]);
        },
        // 获得裁剪后图片base64
        getCropImgBase( imgUrl )　{
            this.logoImgUrl = imgUrl;
        },
        // 上传店铺信息
        uploadStoreInfo(){
            this.$http({
                url:"update-storeDetail",
                method:"POST",
                data:{
                    storeId:this.curStoreId,
                    detail:this.desc,
                    logo:this.logoImgUrl
                }
            }).then(res=>{
                console.log(res);
                if(res.status == 200){
                    this.$message({
                        message: res.data,
                        customClass: 'success'
                    })
                }
            })
        }
    },
    mounted () {
        this.$http({
            url:"stores/"+this.curStoreId,
            method:"GET"
        }).then(res=>{
            console.log(res);
            if(res.status == 200){
                this.logoImgUrl = res.data.storeLogo;
                this.desc = res.data.summary;
            }
        });
    }
}
</script>

<style scoped lang="scss">
    @import "./voiceCall.scss";
</style>



// WEBPACK FOOTER //
// voiceCall.vue?736b4df6